import store from '@/store/store.js';
import { ref } from 'vue';
import { ajax200Res } from '@/js/utils';
import { Other } from "@/js/services/baseService";
import { pendingPromise } from "@/js/utils.js";
import { f7ready, f7 } from "framework7-vue";
export default {
  emits: ["init"],
  data: function data() {
    return {
      refRoot: null,
      cData: {
        list: [],
        pic_src: "",
        url_link: "",
        swiper: {},
        swiperPromise: pendingPromise()
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    f7ready(function () {
      _this.checkLightCommercial();

      _this.cData.swiperPromise.promise.then(function () {
        _this.$emit("init", {
          checkLightCommercial: _this.checkLightCommercial
        });
      });
    });
  },
  methods: {
    onSwiper: function onSwiper(swiper) {
      this.cData.swiper = swiper;
      this.cData.swiperPromise.resolve();
    },
    onAfterInit: function onAfterInit() {
      var _this2 = this;

      this.cData.swiperPromise.promise.then(function () {
        setTimeout(function () {
          _this2.cData.swiper.update();
        }, 300);
      });
    },
    openLink: function openLink(link, open_type) {
      if (open_type === "browser") {
        _open_browser(link);
      }

      if (open_type === "innerPage") {
        f7.popup.close("#popup-light_commercial");

        _direct_page(link);
      }
    },
    dontShowToday: function dontShowToday() {
      var now = new Date();
      var today235959 = now.setHours(23, 59, 59);
      this.$store.commit("setData", {
        adModalHideUntil: today235959
      });
      f7.popup.close(this.$refs.refRoot);
    },
    dontShowThisLogin: function dontShowThisLogin() {
      this.$store.commit("setData", {
        adModalHideThisLogin: true
      });
    },
    checkLightCommercial: function checkLightCommercial(isEnterForground) {
      var _this3 = this;

      var parseUrl = f7.utils.parseUrlQuery(location.href);
      if (!this.$store.state.auth.isLogined) return;
      if (parseUrl.go_page) return;
      var until = this.$store.state.adModalHideUntil;
      if (until && until >= Date.now()) return;
      if (this.$store.state.adModalHideThisLogin) return;
      return Other.get_light_commercial().then(function (res) {
        ajax200Res(res, function (_ref) {
          var data = _ref.data;

          if (Array.isArray(data)) {
            _this3.cData.list = data;
          }
        }, function (_ref2) {
          var defaultAlert = _ref2.defaultAlert;
          defaultAlert();
        });
      }).finally(function () {
        _this3.cData.swiperPromise.promise.then(function () {
          _this3.cData.swiper.update();
        });

        if (_this3.cData.list && _this3.cData.list.length) {
          f7.popup.open(_this3.$refs.refRoot);
        }
      });
    }
  }
};